var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "700" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-card-content" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-textarea", {
                    attrs: { fancy: "", label: _vm.$ct("default-value") },
                    model: {
                      value: _vm.config.DefaultValue,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "DefaultValue", $$v)
                      },
                      expression: "config.DefaultValue",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-select", {
                    attrs: {
                      fancy: "",
                      items: _vm.inputTypeMetaData,
                      label: _vm.$ct("extra-fields-input-type"),
                    },
                    model: {
                      value: _vm.config.InputType,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "InputType", $$v)
                      },
                      expression: "config.InputType",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.isAutocompleteSelected
            ? _c("app-extra-field-text-options-meta-data-autocomplete", {
                model: {
                  value: _vm.config.InputMetaData,
                  callback: function ($$v) {
                    _vm.$set(_vm.config, "InputMetaData", $$v)
                  },
                  expression: "config.InputMetaData",
                },
              })
            : _vm._e(),
          _vm.isSelect || _vm.isMultiSelect
            ? _c("app-extra-field-text-options-meta-data-select", {
                model: {
                  value: _vm.config.InputMetaData,
                  callback: function ($$v) {
                    _vm.$set(_vm.config, "InputMetaData", $$v)
                  },
                  expression: "config.InputMetaData",
                },
              })
            : _vm._e(),
          _vm.supportsTab
            ? _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: {
                          label: _vm.$ct("extra-field-with-formatting"),
                        },
                        model: {
                          value: _vm.config.WithFormatting,
                          callback: function ($$v) {
                            _vm.$set(_vm.config, "WithFormatting", $$v)
                          },
                          expression: "config.WithFormatting",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("app-extra-field-base-options", {
            attrs: {
              value: _vm.config,
              "extra-fields-type": _vm.extraFieldsType,
            },
          }),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }